import * as React from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import {mobileBreakpoint} from "@src/../entrypoints/theme";

const isFunctionEmpty = (func) => {
    const funcStr = func.toString().replace(/\s/g, '');
    return funcStr === '()=>' || funcStr === '()=>{}' || funcStr === 'function(){}';
};

const MegamenuLinks = ({ hasSubLinks = false, subItem, onLinkHover  = (subItem) => {}, onLinkLeave = () => {}, onLinkClick = (subItem) => {}, isExpanded = false }) => {
    const isMobile = useMobileBreakpoint(mobileBreakpoint);

    let isTitle = false;
    const parseTitle = (title) => {
        if (title.includes('|')) {
            const [firstPart, secondPart] = title.split('|').map(part => part.trim());
            if (secondPart === 'HEADER') {
                isTitle = true;
                return firstPart;
            }
        }
        return title;
    };

    const titleText = parseTitle(subItem.title);
    const spanClass = isTitle ? "b2 megamenu__title" : "b2";

    const handleAnchorClick = (e) => {
        if (isMobile && hasSubLinks && !isTitle) {
            e.preventDefault();
            e.stopPropagation();
            onLinkClick(subItem);
        }
    };

    const handleContainerClick = (e) => {
        if (isMobile && hasSubLinks && !isTitle) {
            e.preventDefault();
            e.stopPropagation();
            onLinkClick(subItem);
        }
    };

    return (
        <div
            key={subItem.handle}
            {...(hasSubLinks && {'data-link-id': subItem.handle})}
            className="megamenu__link-container"
            {...(!isTitle && {
                onMouseEnter: () => onLinkHover(subItem),
                onMouseDown: () => onLinkHover(subItem),
                onMouseLeave: onLinkLeave,
                ...((isMobile && hasSubLinks) 
                    ? { 
                        onClick: handleContainerClick, 
                        style: { cursor: 'pointer' },
                        'data-test': 'mobile-toggle',
                        'aria-expanded': isExpanded,
                        'role': 'button',
                        'aria-controls': `submenu-${subItem.handle}`
                      }
                    : { onClick: () => onLinkClick(subItem) }
                )
            })}
        >
            {!isTitle &&
                <a 
                    href={subItem.url}
                    onClick={handleAnchorClick}
                >
                    <span className={spanClass}>{titleText}</span>
                </a>
            }
            {isTitle && <a href="#">
                <span className={spanClass}>{titleText}</span>
            </a>}
            {!isTitle && !isFunctionEmpty(onLinkClick) && hasSubLinks && <i className={'icon-arrow-right lg:hidden'}></i>}
        </div>
    );
};

export default MegamenuLinks;
